<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import AUApi from "@/api";
import { goBack } from "@/NavigationHelper";
import { mountedBase, onSave, BaseSetup, onDelete } from "@/DataLoaderStatic";

import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
import { showSnackbar } from "@/UIHelper";
import { begriffBezeichnung } from "@/local";
const validator = createEditorValidator();
const emit = defineEmits(["back", "save"]);
const props = defineProps<{
  zeitbereichUebergabe: APIZeitbereich;
  showClose?: boolean;
}>();

let deleteVisible = ref<boolean>(false);
let saveVisible: boolean = true;
let showCloseMutable = ref<boolean>(false);
let noData = ref<boolean>(false);
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "ZE_ErfassungTimer_sortiert",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  showCloseMutable.value = props.showClose;
  pageParams.zeitbereich = props.zeitbereichUebergabe;
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data) {
    noData.value = true;
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
async function bewDelete() {
  if (uiData.data && uiData.data[0].aic_Bew_pool) {
    await onDelete(uiData, pageParams, uiData.data[0].aic_Bew_pool, "");
    emit("back");
  }
}
async function onValidate() {
  return await validator.validateAsync();
}
async function save() {
  const isvalid = await onValidate();
  if (!isvalid.valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" +
        isvalid.invalidFields.join(", ") +
        ")",
      duration: 4000,
      color: "error",
    });
    return;
  }
  // unbedingt testen
  await onSave(uiData, pageParams, 0, "");
  goBack();
}
</script>
<template>
  <v-sheet class="pa-0">
    <v-progress-linear
      :indeterminate="true"
      v-if="uiData.showLoading"
      color="dvhSlider"
    ></v-progress-linear>
    <v-expansion-panels class="pa-0" rounded="0">
      <v-expansion-panel v-if="uiData.initialized">
        <div v-if="noData"> {{
                    begriffBezeichnung(
                      "Web_keineDaten_gefunden",
                      "keine Daten gefunden"
                    )
                  }}</div>
        <v-expansion-panel-title
          disable-icon-rotate
          v-if="!noData"
          class="subtitle-1 lighten-2 white--text dvhBackground"
        >
          <span style="color: white">{{ uiData.header.bezeichnung }}</span>
          <template v-slot:actions>
            <v-icon color="white">$expand</v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text cols="12" sm="6" lg="6" md="6">
          <!-- <BaseEditor
            :query="pageParams.query"
                 @back="goBack()"
            @save="(item: any) => save"
            :aic="pageParams.aic"

            :showTitle="true"

            :showDeleteButton="false"
            :backOnSave="true"
            :newData="true"
            fieldCssClass="sm6"
            class="pa-5"
            :maxWidth="400"
            :maxHeight="800"
          /> -->
          <EditCheckBox kennung="ZE_KEINE_VERFALLBEGI" />
          <EditCheckBox kennung="ZE_K_VERFALLZEITENDE" />
          <EditCheckBox kennung="ZE_KEINE_PAUSE" />
          <EditTimePicker kennung="ZE_ALTERNATIVE_PAUSE" />
          <EditTimePicker kennung="ZE_AUSZAHLUNG_UEST" />
          <EditCheckBox kennung="ZE_UEST_NICHT_AUSZAH" />
          <v-row>
            <v-spacer></v-spacer>
            <CommonBaseButtons
              :saveVisible="saveVisible"
              :backVisible="showCloseMutable"
              :deleteVisible="deleteVisible"
              :createVisible="false"
              :refreshVisible="false"
              @back="goBack()"
              @delete="bewDelete"
              @save="save"
            ></CommonBaseButtons>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-sheet>
</template>

<style scoped>
.dvhCol {
  padding-right: 0px;
  padding-left: 10px;
  padding-top: 15px;
  padding-bottom: 0px;
}
.colNoPad {
  padding: 0 0 0 0;
}
</style>
